
import { getProductByID, toRollerShutter } from 'modules/shop-front/shop-front-component/ProductCollection'
import GenericProductPage from '../GenericProductPage'
export default function RS50mmEx() {

    return (
        GenericProductPage(getProductByID(64),toRollerShutter)
    )
  }
